import { Link } from 'react-router-dom';

import { cn } from '@/lib/tw-merge/cn';

import {
  AgentousIcon,
  AgentousLogo,
  AgentousLogoWhite,
} from '../../assets/images';
import { ROUTES } from '../../constants/routes';

const Logo = ({ iconOnly = false, theme = 'brand', linked = true }) => {
  const content = (
    <div className={cn('flex items-center justify-start')}>
      {iconOnly ? (
        <img
          className="h-auto max-w-[120px] sm:max-w-[150px]"
          loading="lazy"
          src={AgentousIcon}
          alt="Agentous Logo"
        />
      ) : (
        <img
          className="h-[20.141286849975586px] max-w-[120px] sm:h-auto sm:w-[150px]"
          loading="lazy"
          src={theme === 'brand' ? AgentousLogo : AgentousLogoWhite}
          alt="Agentous Logo"
        />
      )}
    </div>
  );
  return linked ? <Link to={ROUTES.HOME}>{content}</Link> : content;
};

export default Logo;
